import React, { useState } from 'react';
import {
  Box,
  VStack,
  Text,
  Input,
  Button,
  FormControl,
  InputGroup,
  InputRightElement,
  IconButton,
  Alert,
  AlertIcon,
  Flex,
  Image,
} from '@chakra-ui/react';
import { Eye, EyeSlash } from 'phosphor-react';

interface PasswordFormProps {
  // eslint-disable-next-line no-unused-vars
  onSubmit: (pwd: string) => Promise<void>;
  isLoading: boolean;
  error: string | null;
}

export function PasswordForm({ onSubmit, isLoading, error }: PasswordFormProps) {
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password) {
      onSubmit(password);
    }
  };

  return (
    <Flex minH="100vh" align="center" justify="center" bg="blue.600" p={4}>
      <Box bg="blue.600" p={10} w="100%" maxW="420px">
        <VStack spacing={8} align="stretch">
          {/* Logo */}
          <Flex align="center" justify="center">
            <Image
              src="/logoBranca.png"
              alt="Logo Rede Especialistas"
              objectFit="contain"
              w="180px"
              h="180px"
            />
          </Flex>

          {/* Textos */}
          <VStack spacing={2}>
            <Text fontSize="2xl" fontWeight="bold" color="white" textAlign="center">
              Acesso ao Dossiê
            </Text>
            <Text fontSize="sm" color="blue.100" textAlign="center">
              Digite a senha fornecida para acessar os dados
            </Text>
          </VStack>

          {/* Erro */}
          {error && (
            <Alert status="error" borderRadius="lg" bg="red.500" color="white">
              <AlertIcon color="white" />
              <Text fontSize="sm">{error}</Text>
            </Alert>
          )}

          {/* Formulário */}
          <form onSubmit={handleSubmit}>
            <VStack spacing={5}>
              <FormControl>
                <InputGroup>
                  <Input
                    type={showPassword ? 'text' : 'password'}
                    placeholder="Digite a senha"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    size="lg"
                    bg="white"
                    color="gray.800"
                    borderRadius="lg"
                    border="none"
                    _placeholder={{ color: 'gray.400' }}
                    _focus={{ boxShadow: '0 0 0 3px rgba(255,255,255,0.3)' }}
                    sx={{
                      '&::-ms-reveal': { display: 'none' },
                      '&::-webkit-credentials-auto-fill-button': { display: 'none' },
                    }}
                  />
                  <InputRightElement h="100%">
                    <IconButton
                      aria-label={showPassword ? 'Ocultar senha' : 'Mostrar senha'}
                      icon={showPassword ? <EyeSlash size={20} /> : <Eye size={20} />}
                      variant="ghost"
                      color="gray.500"
                      _hover={{ bg: 'gray.100' }}
                      onClick={() => setShowPassword(!showPassword)}
                    />
                  </InputRightElement>
                </InputGroup>
              </FormControl>

              <Button
                type="submit"
                bg="white"
                color="blue.600"
                size="lg"
                w="100%"
                borderRadius="lg"
                fontWeight="bold"
                isLoading={isLoading}
                loadingText="Verificando..."
                isDisabled={!password}
                _hover={{ bg: 'blue.50' }}
                _active={{ bg: 'blue.100' }}
              >
                Acessar Dossiê
              </Button>
            </VStack>
          </form>
        </VStack>
      </Box>
    </Flex>
  );
}
